import pick from 'latest_modules/lodash/pick';

import ShoppingDiscounts from '../schema/ShoppingDiscounts';
import shoppingDiscountsApi from '../../api/shoppingDiscounts';

import { SHOPPING_DISCOUNTS as shoppingDiscountsTypes } from '../mutation-types';

ShoppingDiscounts.state.subscribedPremiumServices = [];
ShoppingDiscounts.state.subscribedAvailablePremiumServices = [];

// Getters
const getters = Object.assign(ShoppingDiscounts.getters, {
  getSubscribedPremiumServices(state) {
    return state.subscribedPremiumServices;
  },

  getSubscribedAvailablePremiumServices(state) {
    return state.subscribedAvailablePremiumServices;
  }
});

// Actions
const actions = {
  insert({
    dispatch,
    commit
  }, payload = {}) {
    const discountData = pick(payload, [
      '_id',
      'created_at', // `/orders/api`では使用しない
      'within_period', // `/orders/api`では使用しない
      'display_expires',
      'display_use_start'
    ]);

    if (payload.coupon && payload.coupon._id) {
      dispatch('shoppingCoupons/insert', payload.coupon, {
        root: true
      });
      discountData.coupon = payload.coupon._id;
    }

    commit(shoppingDiscountsTypes.UPSERT, discountData);
  },

  fetchAll({
    dispatch,
    commit
  }, payload = {}) {
    return new Promise((resolve, reject) => {
      shoppingDiscountsApi.fetchAll({
          wishlistId: payload.wishlistId
        },
        (err, res) => {
          if (err) {
            return reject(err);
          }

          res.discounts.forEach((discount) => {
            if (discount.coupon && discount.coupon._id) {
              dispatch('shoppingCoupons/insert', discount.coupon, {
                root: true
              });
              discount.coupon = discount.coupon._id;
            }
          });

          commit(shoppingDiscountsTypes.DATA_RECEIVED, res);

          resolve(res);
        }
      );
    });
  },

  updateCoupon({
    dispatch,
    rootGetters
  }, payload = {}) {
    return new Promise((resolve, reject) => {
      shoppingDiscountsApi.updateCoupon({
          wishlistId: payload.wishlistId,
          discountId: payload.discountId,
          isUse: payload.isUse
        },
        (err, res) => {
          if (err) {
            return reject(err);
          }

          const cart = rootGetters['cart/current']({
            populate: ['shipments']
          });

          // populateしたcart.shipmentsをDeepコピー
          const shipments = JSON.parse(JSON.stringify(cart.shipments));

          dispatch(
            'shipments/update', {
              shipments: shipments,
              shippingChargesMap: res.shippingChargesMap
            }, {
              root: true
            }
          );

          dispatch(
            'cart/updatePrice', {
              cart: res.prices
            }, {
              root: true
            }
          );

          resolve(res);
        }
      );
    });
  },

  redeemCoupon({
    dispatch,
    commit
  }, payload = {}) {
    return new Promise((resolve, reject) => {
      shoppingDiscountsApi.redeemCoupon({
          wishlistId: payload.wishlistId,
          couponCode: payload.couponCode
        },
        (err, res) => {
          if (err) {
            return reject(err);
          }

          if (res.discount.coupon && res.discount.coupon._id) {
            dispatch('shoppingCoupons/insert', res.discount.coupon, {
              root: true
            });
            res.discount.coupon = res.discount.coupon._id;
          }

          commit(shoppingDiscountsTypes.UPSERT, res.discount);

          resolve(res);
        }
      );
    });
  }
};

const updateDiscount = (discount) => {
  ShoppingDiscounts.update({
    _id: discount._id
  }, {
    _id: discount._id,
    coupon: discount.coupon,
    created_at: discount.created_at,
    within_period: discount.within_period,
    display_expires: discount.display_expires,
    display_use_start: discount.display_use_start
  }, {
    upsert: true
  });
};

// Mutations
const mutations = {
  [shoppingDiscountsTypes.DATA_RECEIVED](state, payload) {
    state.subscribedPremiumServices = payload.subscribedPremiumServices;
    state.subscribedAvailablePremiumServices =
      payload.subscribedAvailablePremiumServices;

    payload.discounts.map((discount) => {
      updateDiscount(discount);
    });
  },

  [shoppingDiscountsTypes.UPSERT](state, payload) {
    updateDiscount(payload);
  }
};

export default {
  namespaced: true,
  state: ShoppingDiscounts.state,
  getters: getters,
  actions,
  mutations
};
